import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RandomService {
    private firstNames: string[] = [
        'James', 'Mary', 'Robert', 'Patricia', 'John', 'Jennifer', 'Michael', 'Linda',
        'David', 'Elizabeth', 'William', 'Barbara', 'Richard', 'Susan', 'Joseph', 'Jessica',
        'Thomas', 'Sarah', 'Charles', 'Karen', 'Christopher', 'Lisa', 'Daniel', 'Nancy',
        'Matthew', 'Betty', 'Anthony', 'Margaret', 'Mark', 'Sandra', 'Donald', 'Ashley',
        'Steven', 'Kimberly', 'Paul', 'Emily', 'Andrew', 'Donna', 'Joshua', 'Michelle',
        'Kenneth', 'Carol', 'Kevin', 'Amanda', 'Brian', 'Dorothy', 'George', 'Melissa',
        'Timothy', 'Deborah', 'Ronald', 'Stephanie', 'Edward', 'Rebecca', 'Jason', 'Sharon',
        'Jeffrey', 'Laura', 'Ryan', 'Cynthia', 'Jacob', 'Kathleen', 'Gary', 'Amy', 'Nicholas',
        'Angela', 'Eric', 'Shirley', 'Jonathan', 'Anna', 'Stephen', 'Brenda', 'Larry', 'Pamela',
        'Justin', 'Emma', 'Scott', 'Nicole', 'Brandon', 'Helen', 'Benjamin', 'Samantha', 'Samuel',
        'Katherine', 'Gregory', 'Christine', 'Alexander', 'Debra', 'Frank', 'Rachel', 'Patrick',
        'Carolyn', 'Raymond', 'Janet', 'Jack', 'Catherine', 'Dennis', 'Maria', 'Jerry', 'Heather',
        'Tyler', 'Diane', 'Aaron', 'Ruth', 'Jose', 'Julie', 'Adam', 'Olivia', 'Nathan', 'Joyce',
        'Henry', 'Virginia', 'Douglas', 'Victoria', 'Zachary', 'Kelly', 'Peter', 'Lauren', 'Kyle',
        'Christina', 'Ethan', 'Joan', 'Walter', 'Evelyn', 'Noah', 'Judith', 'Jeremy', 'Megan',
        'Christian', 'Andrea', 'Keith', 'Cheryl', 'Roger', 'Hannah', 'Terry', 'Jacqueline', 'Gerald',
        'Martha', 'Harold', 'Gloria', 'Sean', 'Teresa', 'Austin', 'Ann', 'Carl', 'Sara', 'Arthur',
        'Madison', 'Lawrence', 'Frances', 'Dylan', 'Kathryn', 'Jesse', 'Janice', 'Jordan', 'Jean',
        'Bryan', 'Abigail', 'Billy', 'Alice', 'Joe', 'Julia', 'Bruce', 'Judy', 'Gabriel', 'Sophia',
        'Logan', 'Grace', 'Albert', 'Denise', 'Willie', 'Amber', 'Alan', 'Doris', 'Juan', 'Marilyn',
        'Wayne', 'Danielle', 'Elijah', 'Beverly', 'Randy', 'Isabella', 'Roy', 'Theresa', 'Vincent',
        'Diana', 'Ralph', 'Natalie', 'Eugene', 'Brittany', 'Russell', 'Charlotte', 'Bobby', 'Marie',
        'Mason', 'Kayla', 'Philip', 'Alexis', 'Louis', 'Lori', 'Owen', 'Denis', 'Deepak', 'Adriana',
        'Alyssa', 'Antonia', 'Brooke', 'Caitlyn', 'Carly', 'Clarence', 'Delvin', 'Jake', 'Jimmie',
        'Josh', 'Kerry', 'Myria', 'Paige', 'Tim', 'Zach', 'Cherry', 'Gina', 'Garrett',
    ];

    private lastNames: string[] = [
        'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Nance', 'Walton', 'Rose', 'Heller',
        'Newton', 'Hernandez', 'Lopez', 'Gonzales', 'Munn', 'Anderson', 'Thomas', 'Taylor', 'Moore',
        'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Duffy', 'Ramirez',
        'Wilson', 'Samario', 'Hersh', 'Washington', 'Allen', 'Ward', 'Wright', 'Francois', 'Baxter', 'Solomon',
        'Chandler', 'Malmstrom', 'Zawada', 'Zachary', 'Britt', 'Baker', 'Hansen', 'Koeller', 'Specht', 'Douglas',
        'Ackley', 'Creekmur', 'McElroy', 'Nerolich', 'Cunningham', 'Payao', 'Nardone', 'Tyre', 'Bassick', 'Bedolla',
        'Webster', 'Villanueva', 'Holland', 'Webber', 'Abernethy', 'Grace', 'Patel', 'Bennett', 'Wayne', 'Wagner',
        'Morgan', 'Cooper', 'Peterson', 'Banner', 'Madden', 'Barton', 'Grant', 'Ramos', 'Kim', 'Cox', 'Ward',
        'Richardson', 'Watson', 'Luther', 'Villagomez', 'Drayah', 'James', 'Bennet', 'Gray', 'Mendoza', 'Ruiz',
        'Hughes', 'Price', 'Alvarez', 'Castillo', 'Sanders', 'Chernyvskij', 'Resnik', 'Bockman', 'Lord', 'Whitmore',
        'Allan', 'Williamson', 'Gonzalez', 'Voorhees', 'Dunn', 'Burke', 'Davis', 'Miller', 'Garcia', 'Martinez',
        'Robinson', 'Clark', 'Rodriguez', 'Lewis', 'Walker', 'Young', 'King', 'Scott', 'Torres', 'Nguyen',
        'Hill', 'Flores', 'Green', 'Adams', 'Nelson', 'Hall', 'Rivera', 'Campbell', 'Mitchell',
        'Carter', 'Roberts', 'Gomez', 'Phillips', 'Evans', 'Turner', 'Diaz', 'Parker', 'Cruz', 'Edwards',
        'Collins', 'Reyes', 'Stewart', 'Morris', 'Morales', 'Murphy', 'Cook', 'Rogers', 'Gutierrez', 'Ortiz',
        'Dougherty', 'Harrington', 'Meyers', 'Bailey', 'Reed', 'Kelly', 'Howard', 'Crew', 'Abreu', 'Dukes', 'Chase',
        'Haggerty', 'Buchanan', 'Brooks', 'Chavez', 'Wood', 'Gibbs', 'Ventura', 'Ham', 'Goodman', 'Nolan',
        'Stanley', 'Keyser', 'Marshall', 'Kane', 'Garbart', 'Patel', 'Myers', 'Long', 'Ross', 'Foster',
        'Jimenez', 'Snyder', 'Kink', 'Terranova', 'Verma', 'Griffin', 'Jacobs', 'Barnes', 'Coppola', 'Spillman',
        'Bryant', 'Carlson', 'Bramley', 'Neal', 'Norman',
    ];

    private letters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    private domains: string[] = [
        'com', 'net', 'org', 'eu', 'gov', 'co', 'co.uk', 'io', 'ai', 'info',
        'biz', 'edu', 'de', 'es', 'fr', 'it', 'ca', 'nl', 'jp', 'ru', 
    ];

    private getRandomItem = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];

    private generateConsumer() {
        const firstName = this.getFirstName() + this.getLetters(2);
        const lastName = this.getLastName() + this.getLetters(2);

        this.consumer = {
            firstName: firstName,
            lastName: lastName,
            phoneNumber: this.getInt({min: 1000000000, max: 9999999999}),
            emailAddress: this.getEmail({user: firstName, server: lastName}),
            streetAddress: '123 Main St',
            zipCode: this.getInt({min: 10000, max: 99999}),
        }
    }

    public consumer: {
        firstName: string,
        lastName: string,
        phoneNumber: number,
        emailAddress: string,
        streetAddress: string,
        zipCode: number,
    };

    constructor() {
        this.generateConsumer();
    }

    /**
     * Dev test auto-fill is OPT-IN (off by default) so it never clobbers the
     * user's real browser autofill on the contact steps. Re-enable for a dev
     * session with `?testfill=1` in the URL or localStorage `fru_testfill=1`.
     */
    public get fillEnabled(): boolean {
        try {
            if (typeof window === 'undefined') { return false; }
            if (/[?&]testfill=1(?=&|$)/.test(window.location.search)) { return true; }
            return !!(window.localStorage && window.localStorage.getItem('fru_testfill') === '1');
        } catch (e) {
            return false;
        }
    }

    public getEmail(options: {user?: string, server?: string, domain?: string}): string {
        const user = options.user || this.getRandomItem(this.firstNames);
        const server = options.server || this.getRandomItem(this.lastNames);
        const domain = options.domain || this.getRandomItem(this.domains);

        return user + '@' + server + '.' + domain;
    }

    public getInt(options: {min?: number, max?: number}): number {
        const min = Math.ceil(options.min ?? 0);
        const max = Math.floor(options.max ?? 10);

        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public getLetters(length: number = 1): string {
        let letter: string = '';

        for (let i= 0; i < length; i++) {
            letter += this.getRandomItem(this.letters.split(''));
        }

        return letter;
    }

    public getFirstName(): string {
        return this.getRandomItem(this.firstNames);
    }

    public getLastName(): string {
        return this.getRandomItem(this.lastNames);
    }
}
